import { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function LoginView() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (auth.user) navigate('/', { replace: true });
  }, [auth.user, navigate]);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (auth.pendingChallenge) {
        await auth.completeNewPassword(newPassword);
      } else {
        await auth.signIn(email, password);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  if (!auth.configured) {
    return (
      <div className="login-card">
        <h2>Sign in</h2>
        <p className="error">
          Auth is not configured. Set <code>VITE_USER_POOL_ID</code> and{' '}
          <code>VITE_USER_POOL_CLIENT_ID</code> in <code>src/frontend/.env.local</code>{' '}
          and restart the dev server.
        </p>
      </div>
    );
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <h2>Sign in</h2>
        {error && <div className="error">{error}</div>}
        {auth.pendingChallenge ? (
          <>
            <p className="muted">Set a new password to finish setting up your account.</p>
            <label>
              <span>New password</span>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={8}
                autoFocus
              />
            </label>
          </>
        ) : (
          <>
            <label>
              <span>Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </label>
            <label>
              <span>Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>
          </>
        )}
        <button type="submit" className="primary" disabled={busy}>
          {busy ? 'Signing in…' : auth.pendingChallenge ? 'Set password' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
